export enum Category {
  Title = "Title",
  Banner = "Media slot 1",
  Links = "Links",
  Question = "Question",
  Answers = "Answers",
  Responses = "Media slot 2",
  Share = "Share"
}
